"use client";

import { useEffect } from "react";

function decodeBase64Utf8(b64: string): string {
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export default function MermaidRuntime() {
  useEffect(() => {
    const nodes = Array.from(
      document.querySelectorAll<HTMLElement>("div.mermaid[data-mermaid]"),
    );
    if (nodes.length === 0) return;

    let cancelled = false;
    void (async () => {
      const mermaid = (await import("mermaid")).default;
      mermaid.initialize({ startOnLoad: false });
      for (const el of nodes) {
        const encoded = el.getAttribute("data-mermaid");
        if (!encoded) continue;
        const source = decodeBase64Utf8(encoded);
        try {
          const id = `mmd-${Math.random().toString(36).slice(2)}`;
          const { svg } = await mermaid.render(id, source);
          if (cancelled) return;
          el.innerHTML = svg;
          el.removeAttribute("data-mermaid");
        } catch {
          // 语法错误则保留占位，不影响其余内容
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
